var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmoothArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 27,
    viewBox: "0 0 82 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1917_2674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4195 20.735C16.2064 21.3258 17.986 21.9749 19.7948 22.4855C21.1368 22.8647 22.0849 23.492 21.6911 25.0163C21.341 26.3437 20.1667 26.6136 19.0581 26.3146C13.0847 24.6881 7.10408 23.0179 1.72878 19.8598C-0.678069 18.4449 -0.568671 16.658 2.06428 15.739C7.66568 13.7697 13.3838 12.1141 19.0581 10.371C20.0792 10.0574 21.093 10.2762 21.4431 11.4139C21.7932 12.559 20.9763 13.2592 20.05 13.6676C18.3069 14.4407 16.5127 15.0972 14.558 15.8776C15.6593 16.7309 16.7534 16.2277 17.7307 16.1912C27.6936 15.8119 37.6492 16.1839 47.6048 16.2641C54.5628 16.3152 61.4406 15.6588 68.0047 13.1425C73.2561 11.1295 77.2821 7.86202 78.522 2.02723C78.7626 0.889444 79.0471 -0.306689 80.5277 0.0871619C81.9718 0.473717 81.6509 1.81572 81.4539 2.85139C80.3234 8.781 76.8226 12.8872 71.4837 15.5056C65.1384 18.6126 58.3044 19.6994 51.3464 19.7942C40.2968 19.9546 29.2471 19.8379 18.1902 19.8525C16.9868 19.8525 15.7906 19.9546 14.5872 20.013C14.5289 20.261 14.4778 20.5089 14.4195 20.7496L14.4195 20.735Z",
    fill: "#D7CCFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1917_2674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.6215,
    height: 26.4243,
    fill: "white",
    transform: "translate(81.6211 26.4243) rotate(-180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoothArrowLeft);
export default __webpack_public_path__ + "static/media/SmoothArrowLeft.275495b2a23ccd1f001453f561359b32.svg";
export { ForwardRef as ReactComponent };